import { render, staticRenderFns } from "./RoleSelector.vue?vue&type=template&id=c922c336&scoped=true&"
import script from "./RoleSelector.vue?vue&type=script&lang=ts&"
export * from "./RoleSelector.vue?vue&type=script&lang=ts&"
import style0 from "./RoleSelector.vue?vue&type=style&index=0&id=c922c336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c922c336",
  null
  
)

export default component.exports